// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"c537bf9c","172":"4ffd1e06","340":"ccfb84b4","651":"54509489","860":"06d545dd","866":"4c60e009","872":"34759b36","948":"1fde95a0"}[chunkId] + ".chunk.js";
};